<template>
  <div class="g-page">
    <div class="content-container">
      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Takliflar</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <button class="refresh-btn" @click="Data()" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <button class="add-btn" @click="OpenModal()">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 80px">ID</th>
                <th style="width: 100px">{{ $t("Rasm") }}</th>
                <th>{{ $t("Nomi") }}</th>
                <th style="width: 120px; text-align: center;">{{ $t("Amallar") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedItems" :key="item.id" @dblclick="Update(item)">
                <td><span class="id-badge">#{{ item.id }}</span></td>
                <td>
                  <div class="brand-img-wrapper">
                    <img v-if="item.image" :src="getImagePath(item.image)" class="brand-img">
                    <div v-else class="no-img-placeholder">{{ $t("Rasm yo'q") }}</div>
                  </div>
                </td>
                <td class="font-bold">{{ item.name }}</td>
                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click="Update(item)">
                      <b-icon icon="pencil"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredItems.length === 0">
                <td colspan="4" class="empty-row text-center">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- PAGINATION -->
        <div class="table-footer">
          <div class="info">
            {{ totalRows }} {{ $t('ta listdan') }}
            {{ Math.min(currentPage * $store.state.countindex, totalRows) }} {{ $t('tasi') }}
          </div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="$store.state.countindex" align="right"
            size="sm" class="my-0 custom-pagination"></b-pagination>
        </div>
      </div>
    </div>

    <!-- FORM MODAL (Tahrirlash va Qo'shish) -->
    <b-modal id="offer-modal" :title="isEdit ? $t('Tahrirlash') : $t('Qo\'shish')" hide-footer centered>
      <div v-if="modalLoading" class="text-center py-5">
        <b-spinner variant="primary"></b-spinner>
        <p class="mt-3 text-muted">{{ $t("Ma'lumotlar yuklanmoqda...") }}</p>
      </div>

      <form v-else @submit.prevent="SaveData">
        <div class="form-group">
          <label class="font-weight-bold text-secondary">{{ $t("Nomi") }}</label>
          <input v-model="form.name" type="text" class="form-control modern-input" required>
        </div>

        <div class="form-group mt-4">
          <label class="font-weight-bold text-secondary">{{ $t("Rasm") }}</label>
          <div class="image-upload-zone" :class="{ 'has-image': previewImage || form.image }"
            @click="$refs.fileInput.click()">
            <input type="file" ref="fileInput" @change="handleFileUpload()" style="display: none" accept="image/*" />

            <div v-if="!previewImage && !form.image" class="upload-placeholder text-center">
              <b-icon icon="cloud-upload" font-scale="3" class="mb-2 text-primary"></b-icon>
              <p class="mb-0 text-secondary small">{{ $t("Rasm yuklash uchun bosing") }}</p>
            </div>

            <div v-else class="upload-preview-container">
              <img :src="previewImage ? previewImage : getImagePath(form.image)" class="img-preview" />
              <div class="upload-overlay">
                <b-icon icon="camera" font-scale="2" class="text-white"></b-icon>
              </div>
            </div>
          </div>
          <div class="text-center mt-2" v-if="previewImage || form.image">
            <button type="button" class="btn btn-link text-danger btn-sm text-decoration-none" @click.stop="ClearImage()">
              <b-icon icon="trash"></b-icon> {{ $t("Rasmni o'chirish") }}
            </button>
          </div>
        </div>

        <div class="modal-custom-footer mt-4 pt-3 border-top">
          <button type="button" class="m-btn cancel-btn" @click="$bvModal.hide('offer-modal')">
            {{ $t("Bekor qilish") }}
          </button>
          <button type="submit" class="m-btn save-btn" :disabled="loading">
            <b-spinner small v-if="loading" class="mr-1"></b-spinner>
            {{ loading ? $t('Saqlanmoqda...') : $t('Saqlash') }}
          </button>
        </div>
      </form>
    </b-modal>

    <!-- O'CHIRISHNI TASDIQLASH MODALI -->
    <b-modal id="modal-delete" hide-footer centered no-stacking>
      <div class="text-center p-3">
        <div class="warning-icon mb-3">!</div>
        <h3 class="fw-bold mb-2">{{ $t("O'chirishni tasdiqlaysizmi?") }}</h3>
        <p class="text-muted mb-4">{{ $t("Ushbu amalni ortga qaytarib bo'lmaydi.") }}</p>
        <div class="modal-custom-footer">
          <button class="m-btn cancel-btn" @click="$bvModal.hide('modal-delete')">{{ $t("YO'Q") }}</button>
          <button class="m-btn save-btn bg-danger" @click="confirmDelete">{{ $t("HA, O'CHIRILSIN") }}</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Top from "../../Layout/Top.vue";
import { print } from "../../../components/mixins/print.js";

export default {
  mixins: [print],
  components: { Top },
  data() {
    return {
      items: [],
      totalRows: 0,
      currentPage: 1,
      filter: "",
      isEdit: false,
      loading: false,
      modalLoading: false,
      selectedFile: null,
      previewImage: null,
      selectedId: null, // O'chirish uchun ID
      form: { id: null, name: '', image: '' },
      rule: { change: true }
    };
  },
  computed: {
    hasPermission() {
      return this.rule && this.rule.change;
    },
    filteredItems() {
      if (!this.filter) return this.items;
      const s = this.filter.toLowerCase();
      return this.items.filter(item =>
        item.name.toLowerCase().includes(s) ||
        item.id.toString().includes(s)
      );
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.$store.state.countindex;
      return this.filteredItems.slice(start, start + this.$store.state.countindex);
    }
  },
  watch: {
    filter() {
      this.currentPage = 1;
      this.totalRows = this.filteredItems.length;
    }
  },
  created() {
    this.Data();
  },
  methods: {
    getImagePath(imgName) {
      if (!imgName) return '';
      let baseUrl = (axios.defaults.baseURL || 'http://192.168.88.135:3000').replace(/\/$/, "");
      if (baseUrl.includes('/api/v1')) {
        return `${baseUrl}/uploads/${imgName}`;
      }
      return `${baseUrl}/api/v1/uploads/${imgName}`;
    },
    Data() {
      axios.get("api/v1/offers/").then(res => {
        this.items = res.data;
        this.totalRows = this.items.length;
      });
    },
    handleFileUpload() {
      const file = this.$refs.fileInput.files[0];
      if (file) {
        this.selectedFile = file;
        this.previewImage = URL.createObjectURL(file);
      }
    },
    ClearImage() {
      this.selectedFile = null;
      this.previewImage = null;
      this.form.image = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    OpenModal() {
      this.isEdit = false;
      this.modalLoading = false;
      this.form = { id: null, name: '', image: '' };
      this.previewImage = null;
      this.$bvModal.show('offer-modal');
    },
    async Update(item) {
      this.isEdit = true;
      this.form = { id: null, name: '', image: '' };
      this.previewImage = null;
      this.$bvModal.show('offer-modal');

      this.modalLoading = true;
      try {
        const res = await axios.get(`api/v1/offers/id/${item.id}`);
        if (res.data) {
          this.form = { ...res.data };
        }
      } catch (err) {
        console.error(err);
        this.$bvModal.hide('offer-modal');
      } finally {
        this.modalLoading = false;
      }
    },
    SaveData() {
      this.loading = true;
      let formData = new FormData();
      formData.append("name", this.form.name);
      if (this.selectedFile) formData.append("image", this.selectedFile);

      let url = this.isEdit ? `api/v1/offers/id/${this.form.id}` : "api/v1/offers/";
      let method = this.isEdit ? "patch" : "post";

      axios({ method, url, data: formData })
        .then(() => {
          this.$bvModal.hide('offer-modal');
          this.Data();
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    // O'chirish tugmasi bosilganda
    Trash(id) {
      this.selectedId = id;
      this.$bvModal.show('modal-delete');
    },
    // Modalda tasdiqlanganda haqiqiy o'chirish
    confirmDelete() {
      axios.delete("api/v1/offers/id/" + this.selectedId).then(() => {
        this.$bvModal.hide('modal-delete');
        this.Data();
      });
    }
  }
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
  font-size: 14px;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 38px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 15px;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 8px;
  font-family: monospace;
  font-weight: 700;
  color: #64748b;
}

.brand-img-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  overflow: hidden;
  background: #f8fafc;
}

.brand-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.image-upload-zone {
  width: 100%;
  height: 180px;
  border: 2px dashed #cbd5e0;
  border-radius: 15px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.img-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(161, 66, 244, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s;
}

.image-upload-zone:hover .upload-overlay {
  opacity: 1;
}

.modal-custom-footer {
  display: flex;
  gap: 10px;
}

.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel-btn {
  background: #f1f5f9;
  color: #64748b;
}

.save-btn {
  background: #a142f4;
  color: white;
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
}

.empty-row {
  text-align: center;
  padding: 50px;
  color: #cbd5e1;
}

/* O'chirish modali uchun ogohlantirish belgisi */
.warning-icon {
  width: 60px;
  height: 60px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
}

.fw-bold {
  font-weight: 700;
}
</style>